import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import Award from "./Award";

const imageDir = "https://sva-storage-prod.s3-ap-southeast-2.amazonaws.com/SDG+Icons+2021";

const badges = [
  { name: "Member", hours: 5, url: `${imageDir}/1.-Member-Badge.png` },
  { name: "Bronze", hours: 32, url: `${imageDir}/2.-Bronze-Badge.png` },
  { name: "Silver", hours: 250, url: `${imageDir}/3.-Silver-Badge.png` },
  { name: "Gold", hours: 500, url: `${imageDir}/4.-Gold-Badge.png` },
];

const centerAwards = { justifyContent: ["center", "flex-start"] };

export default function Awards() {
  const { issued_awards: issuedAwards } = useSelector((state) => state.profile);
  const boxStyle = useMemo(
    () => ({
      padding: 3,
      backgroundColor: "#fff",
      boxShadow: "0px 4px 8px rgba(20, 38, 103, 0.04), 0px 0px 2px rgba(20, 38, 103, 0.06), 0px 0px 1px rgba(20, 38, 103, 0.04)",
      borderRadius: 1,
      flex: [null, null, 1],
    }),
    []
  );

  const textStyle = useMemo(
    () => ({
      fontSize: 20,
      fontWeight: 700,
      lineHeight: "23px",
    }),
    []
  );

  const awardsMemo = useMemo(
    () =>
      badges.map(({ url, hours, name }, index) => {
        const gotAward = !!(issuedAwards || []).find((award) => award.id - 1 === index);
        return <Award key={name} url={url} index={index} gotAward={gotAward} name={name} hours={hours} />;
      }),
    [issuedAwards]
  );

  return (
    <Box sx={boxStyle}>
      <Typography sx={textStyle}>Awards</Typography>
      <Box flexDirection="row" flexWrap="wrap" display="flex" mt={1} sx={centerAwards}>
        {awardsMemo}
      </Box>
    </Box>
  );
}
